import { useQuery } from "@tanstack/react-query"
import { getBackofficeWhatsappRoutesQuery } from "modules/backoffice/lib/whatsappRoutes/getBackofficeWhatsappRoutesQuery"

export function useGetBackofficeWhatsappRoutesQuery() {
  return useQuery(getBackofficeWhatsappRoutesQuery())
}
